import React, { useEffect, useState } from "react";
import { fetchReportShelterIntakesExits } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterIntakeDayMetricState {
  data?: any[];
  setSelectedData: (data: any[] | null) => void;
  active: boolean;
  startDate?: string;
  useDatePicker?: boolean;
  onHandleClick?: any;
}

export const ShelterIntakeDayMetric = ({
  data,
  setSelectedData,
  active,
  startDate,
  useDatePicker = false,
  onHandleClick,
}: ShelterIntakeDayMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dayRange, setDateRange] = useState<number>(7);
  const [current, setCurrent] = useState<string>();
  const [currentData, setCurrentData] = useState<any[]>();
  const [readOnly, setReadOnly] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        let range = 7;
        if (startDate) {
          range = getDayRangeFromStartDate(startDate);
          setDateRange(range);
        }
        const recentIntakes = data.filter((item: any) => isWithinLastXDays(item, range + 1));
        const recentIntakesCount = recentIntakes.length.toString();
        setCurrent(recentIntakesCount);
        setCurrentData(recentIntakes);
        if (active) {
          setSelectedData(recentIntakes);
        }
        setReadOnly(false);
        setIsLoading(false);
      } else {
        await getIntakesData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data, startDate, useDatePicker]);

  const getIntakesData = async () => {
    await fetchReportShelterIntakesExits()
      .then((res: any) => {
        const data = res[0].data;
        const range = startDate ? getDayRangeFromStartDate(startDate) : 7;
        setDateRange(range);
        const recentIntakes = data.filter((item: any) => isWithinLastXDays(item, range + 1));
        const recentIntakesCount = recentIntakes.length.toString();
        setCurrent(recentIntakesCount);
        setCurrentData(recentIntakes);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  function getDayRangeFromStartDate(start: string): number {
    const today = new Date();
    today?.setHours(0, 0, 0, 0);
    const startDate = new Date(start);
    startDate?.setHours(0, 0, 0, 0);
    const dayRangeTime: number = today.getTime() - startDate.getTime();
    return Math.ceil(dayRangeTime / (1000 * 60 * 60 * 24)) - 1;
  }

  function isWithinLastXDays(item: any, dayRange: number) {
    const today = new Date();
    const intakeDate = new Date(item.intake_at);
    today?.setHours(0, 0, 0, 0);
    intakeDate?.setHours(0, 0, 0, 0);

    const diffInTime: number = today.getTime() - intakeDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= dayRange; // 7 days + today
  }

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(currentData || null);
    } else {
      setSelectedData(null);
    }
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={`Intakes Last ${dayRange} Days`} total={current} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={`Intakes Last ${dayRange} Days`}
        total={current}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
